import ContactForm from '../components/ContactForm';
import FieldSignal from '../components/FieldSignal';
import Reveal      from '../components/Reveal';

export default function Contacto() {
  return (
    <section
      id="contacto"
      aria-label="Contacto"
      className="relative bg-tierra text-papel px-6 md:px-10 pt-28 md:pt-36 pb-28 overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto">
        <Reveal>
          <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-papel/75">
            03 · CONTACTO
          </div>
        </Reveal>

        <Reveal delay={0.08}>
          <h2
            className="font-display font-display-axes font-normal mt-6 leading-[0.9] tracking-[-0.04em]"
            style={{ fontSize: 'clamp(72px, 11vw, 160px)' }}
          >
            Treinta minutos.
          </h2>
        </Reveal>

        <Reveal delay={0.16}>
          <h3
            className="font-display italic font-display-italic-axes font-light leading-[0.95] tracking-[-0.04em] mb-10"
            style={{ fontSize: 'clamp(56px, 9vw, 140px)' }}
          >
            Sin pitch enlatado.
          </h3>
        </Reveal>

        <Reveal delay={0.24}>
          <p
            className="text-papel/90 leading-[1.55] max-w-2xl mb-10"
            style={{ fontSize: 'clamp(17px, 1.7vw, 21px)' }}
          >
            Te escucho el terreno, te digo si tiene sentido. Si no lo tiene,
            te lo digo.
          </p>
        </Reveal>

        <Reveal delay={0.32}>
          <ContactForm />
        </Reveal>
      </div>

      <FieldSignal className="absolute bottom-9 right-8 hidden md:inline-flex">
        FIELD SIGNAL · LIVE
      </FieldSignal>
    </section>
  );
}
